function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import MeasurementTable from './MeasurementTable';
import MeasurementChart from './MeasurementChart';
import MeasurementDetailChart from './MeasurementDetailChart';
import moment from 'moment';
export default {
  name: 'MeasurementContent',
  components: {
    MeasurementChart: MeasurementChart,
    MeasurementTable: MeasurementTable,
    MeasurementDetailChart: MeasurementDetailChart
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['activeModule', 'showSidebar', 'measurementDatasets', 'loading'])), mapGetters(['person'])), {}, {
    measurementData: function measurementData() {
      return !this.measurementDatasets ? null // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      : this.measurementDatasets.sort(function (a, b) {
        return moment(b.datetime) - moment(a.datetime);
      });
    }
  })
};